// Ingestion statuses are as follows:
// SCHEDULED = 1;
// RUNNING = 2;
// WARNING = 3;
// ERROR = 4;
// SUCCESS = 5;
// CRASHED = 6;
// TRIGGERED_STOP = 7
// STOPPED = 8

export const INGESTION_CONSTANTS = {
  SCHEDULED: 1,
  RUNNING: 2,
  WARNING: 3,
  ERROR: 4,
  SUCCESS: 5,
  CRASHED: 6,
  TRIGGERED_STOP: 7,
  STOPPED: 8,
};

export const INGESTION_STATUS_LABELS = {
  [INGESTION_CONSTANTS.SCHEDULED]: 'Scheduled',
  [INGESTION_CONSTANTS.RUNNING]: 'Running',
  [INGESTION_CONSTANTS.WARNING]: 'Finished',
  [INGESTION_CONSTANTS.ERROR]: 'Failed',
  [INGESTION_CONSTANTS.SUCCESS]: 'Finished',
  [INGESTION_CONSTANTS.CRASHED]: 'Crashed',
  [INGESTION_CONSTANTS.TRIGGERED_STOP]: 'Stopping',
  [INGESTION_CONSTANTS.STOPPED]: 'Stopped',
};

export const INGESTION_STATUS_ICONS = {
  [INGESTION_CONSTANTS.SCHEDULED]: 'scheduled-icon',
  [INGESTION_CONSTANTS.RUNNING]: 'running-icon',
  [INGESTION_CONSTANTS.TRIGGERED_STOP]: 'running-icon',
  [INGESTION_CONSTANTS.WARNING]: 'warning-icon',
  [INGESTION_CONSTANTS.SUCCESS]: 'success-icon',
  [INGESTION_CONSTANTS.CRASHED]: 'error-icon',
  [INGESTION_CONSTANTS.ERROR]: 'error-icon',
  [INGESTION_CONSTANTS.STOPPED]: 'stopped-icon',
};
